import { render } from "./CollapsibleSidebar.vue?vue&type=template&id=2c1e8510&scoped=true&ts=true&lang=pug"
import script from "./CollapsibleSidebar.vue?vue&type=script&lang=ts"
export * from "./CollapsibleSidebar.vue?vue&type=script&lang=ts"

import "./CollapsibleSidebar.vue?vue&type=style&index=0&id=2c1e8510&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1e8510"]])

export default __exports__